export class DomRender {
    static hasClass(ele: Element, cls: string) {
        if (ele) {
            return ele.className.match(new RegExp('(\\s|^)' + cls + '(\\s|$)'));
        }
        return false;
    }

    static addClass(ele: Element, cls: string) {
        if (ele) {
            if (!this.hasClass(ele, cls)) ele.className += " " + cls;
        }
    }

    static removeClass(ele: Element, cls: string) {
        if (ele) {
            if (this.hasClass(ele, cls)) {
                var reg: any = new RegExp('(\\s|^)' + cls + '(\\s|$)');
                ele.className = ele.className.replace(reg, ' ');
            }
        }
    }

}